export const subjectToChange =
  "This is subject to change depending on who " +
  "is in the segment at the point the Communication is sent.";
